import { render, staticRenderFns } from "./ComprobantesPendientesDeCobro.vue?vue&type=template&id=28255e6e&"
import script from "./ComprobantesPendientesDeCobro.vue?vue&type=script&lang=js&"
export * from "./ComprobantesPendientesDeCobro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports